'use strict';

define('subnavigation',['jquery', 'jquery.scrollTo', 'jquery.easing', 'jquery-waypoints', 'jquery-waypoints-sticky'], function ($) {

  var ACTIVE = 'active';
  var
    $header      = $('.header-container'),
    headerHeight = $header.outerHeight(),

    $subNav      = $('.subnavigation-container'),
    $subNavLinks = $subNav.find('a'),
    subNavHeight = $subNav.outerHeight(),

    topShift     = headerHeight + subNavHeight,

    opts = {
      animation_speed: 300,
      animation_easing: 'easeInCirc'
    },

    $scroll_modules = $subNavLinks.map(function(){
      var item = $($(this).attr('href'));
      if (item.length) {
        return item;
      }
    });

  var handlers = {

    documentReady: function() {
      scrollToActiveAnchor();
    },

    windowScroll: function() {
      var
        window_top_pos,
        $one_of_active_modules,
        active_module_top_pos,
        ids = [], $over_scrolled_modules = [];

      window_top_pos = $(window).scrollTop() + topShift;

      $over_scrolled_modules = $scroll_modules.map(function() {
        if ($(this).offset().top < window_top_pos) {
          return this;
        }
      });

      $one_of_active_modules = $over_scrolled_modules[$over_scrolled_modules.length - 1];
      active_module_top_pos = ($one_of_active_modules && $one_of_active_modules.length) ?
                      $one_of_active_modules.offset().top :
                      '';

      $over_scrolled_modules.each(function(){
        var $self = $(this);
        if($self.offset().top === active_module_top_pos) {
          ids.push($self[0].id);
        }
      });

      setActiveMenuLink(ids);

    },

    subNavigationLinkClick: function(e) {
      e.preventDefault();

      var hash = $(this).attr('href');

      if (hash) {
        scrollToSubNav($(hash));
      }

      $('body').addClass('no-module-animation');

      if(history.pushState) {
        history.pushState(null, null, hash);
      }
      else {
        location.hash = hash;
      }
    }
  };

  var setActiveMenuLink = function(ids) {
    var i, $related_link;

    $subNavLinks.removeClass(ACTIVE);
    $subNavLinks.each(function() {
      for(i = 0; i < ids.length; ++i) {
        $related_link = $subNavLinks.filter('[href=#' + ids[i] + ']');
        if($related_link.length) {
          $related_link.addClass(ACTIVE);
        }
      }
    });

  };

  var initialize = function() {
    if(!$subNav.length) {
      return false;
    }

    $('html, body').scrollTop(0);
    initWaypoint();
    attachEvents();
  };

  var initWaypoint = function() {
    $subNav.waypoint('sticky', {
      offset: headerHeight
    });
  };

  var scrollToSubNav = function($el) {
    if ($el.length) {
      $('html, body').stop().animate(
        { scrollTop: ($el.offset().top - topShift) },
        opts.animation_speed,
        opts.animation_easing
      );
    }
  };

  var scrollToActiveAnchor = function() {
    var hash = window.location.hash;
    if(hash) {
      $subNavLinks.filter('[href=' + hash + ']').click();
    }
  };

  var attachEvents = function() {
    $subNavLinks.click(handlers.subNavigationLinkClick);
    $(window).scroll(handlers.windowScroll);
    $(document).ready(handlers.documentReady);
  };

  return {
    init: initialize
  };
});

